var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLangEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "lang_en-a",
    cx: 36,
    cy: 36,
    r: 36
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "lang_en-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lang_en-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#00247D",
    xlinkHref: "#lang_en-a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 4,
    d: "M70.5692363,52.8809923 L63.6863191,62.7108168 L1.4307637,19.1190077 L8.31368094,9.28918315 L70.5692363,52.8809923 Z",
    mask: "url(#lang_en-b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 4,
    d: "M1.4307637,52.8809923 L63.6863191,9.28918315 L70.5692363,19.1190077 L8.31368094,62.7108168 L1.4307637,52.8809923 Z",
    mask: "url(#lang_en-b)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CF142B",
    fillRule: "nonzero",
    stroke: "#FFF",
    strokeWidth: 4,
    d: "M42,29.9990625 L74,30.0000625 L74,42 L42,42 L42,74 L30,74 L30,42 L-2,42 L-2,30 L30,30 L30,-2 L42,-2 L42,29.9990625 Z",
    mask: "url(#lang_en-b)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "#000",
    strokeOpacity: 0.2,
    mask: "url(#lang_en-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLangEn);
export default __webpack_public_path__ + "static/media/lang-en.7cd175ed63c5a77a6d4444a7c9f096c0.svg";
export { ForwardRef as ReactComponent };